import { Statistic, Grid, Card, Icon } from 'semantic-ui-react';

export const MaintenanceStatistics = ({ statistics }) => {
  if (!statistics) return null;

  const { total, unresolved, outOfService, maintenance } = statistics;

  return (
    <Card fluid style={{ marginBottom: '1rem' }}>
      <Card.Content>
        <Card.Header style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Icon name="chart line" />
          Dashboard Statistics
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <Grid
          columns={4}
          stackable
          doubling
          mobile={2}
          tablet={3}
          computer={4}
        >
          <Grid.Column textAlign="center">
            <Statistic size="mini">
              <Statistic.Value>{total}</Statistic.Value>
              <Statistic.Label>Total Issues</Statistic.Label>
            </Statistic>
          </Grid.Column>

          <Grid.Column textAlign="center">
            <Statistic size="mini" color="red">
              <Statistic.Value>{unresolved}</Statistic.Value>
              <Statistic.Label>Pending</Statistic.Label>
            </Statistic>
          </Grid.Column>

          <Grid.Column textAlign="center">
            <Statistic size="mini" color="orange">
              <Statistic.Value>{outOfService}</Statistic.Value>
              <Statistic.Label>Out of Service</Statistic.Label>
            </Statistic>
          </Grid.Column>

          <Grid.Column textAlign="center">
            <Statistic size="mini" color="yellow">
              <Statistic.Value>{maintenance}</Statistic.Value>
              <Statistic.Label>Maintenance</Statistic.Label>
            </Statistic>
          </Grid.Column>

        </Grid>
      </Card.Content>
    </Card>
  );
};

export default MaintenanceStatistics;
